const styles = theme => ({
  coloredIcon: {
    color: theme.palette.secondary.main,
    padding: '0px 10px'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/components/content-footer/content-footer.theme.style.js